
document.addEventListener("DOMContentLoaded", function() {
  //Toplink
  var toplink = document.querySelector("#toplink");
  window.addEventListener('scroll', function(e) {
    if (window.pageYOffset > 500) {
      toplink.style.display = 'block';
    } else {
      toplink.style.display = 'none';
    }
  });
  // Ende Toplink

});

// High-Contrast Mode
const html = document.querySelector('html');
const currentTheme = localStorage.getItem('theme') ? localStorage.getItem('theme') : null;
if (currentTheme) {
    html.dataset.theme = currentTheme;
    if (currentTheme === 'theme-hc') {
        document.querySelector('input[name="high-contrast-mode"]').checked = true;
    }
}
function changeContrast(element){
  if (html.dataset.theme !== 'theme-hc') {
    html.dataset.theme = 'theme-hc';
    localStorage.setItem('theme', 'theme-hc');
  } else {
    html.dataset.theme = 'theme-lc';
    localStorage.setItem('theme', 'theme-lc');
  }
}
// Ende High-Contrast Mode
